// Pub/sub toast bus — bridges code that runs outside Vue setup() (axios
// interceptors, route guards) to the PrimeVue toast service. App.vue
// subscribes once at mount and forwards messages through useToast().
type Severity = 'success' | 'info' | 'warn' | 'danger';

export interface ToastEvent {
  severity: Severity;
  summary: string;
  detail?: string;
  life?: number;
}

type Listener = (event: ToastEvent) => void;
const listeners = new Set<Listener>();

export function publishToast(event: ToastEvent): void {
  for (const listener of listeners) {
    try {
      listener(event);
    } catch {
      // ignore listener errors — never let a toast subscriber break the app
    }
  }
}

export function subscribeToast(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** Test-only escape hatch — clears all subscribers between tests. */
export function clearToastSubscribers(): void {
  listeners.clear();
}
